import { createLazyReactDirective } from '../../shell/ng';

export default createLazyReactDirective(
  async () => (await import('./ReportDataRow')).ReportDataRow,
  'reportDataRow',
  {
    entity: '=',
    isSection: '=',
    isProject: '=',
    isCollapsed: '=',
  },
);
